module.exports = __webpack_public_path__ + "static/media/stars-768.05e99096.webp";